import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mohit/my-carbon-site/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The `}<inlineCode parentName="p">{`<Title>`}</inlineCode>{` component is used to provide a title to a subsequent component
(table, image, video, code block). The `}<inlineCode parentName="p">{`Title`}</inlineCode>{` should be used in favor of other
techniques for bolded text (`}<inlineCode parentName="p">{`h4`}</inlineCode>{`s) to preserve page structure and heading
hierarchy.`}</p>
    </PageDescription>
    <h2>{`Example`}</h2>
    <Title mdxType="Title">This is a title</Title>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsSAAALEgHS3X78AAABxElEQVQoz33PYWvTQBgH8HutQ/TbOPwC86O0s2mTdOCLvRCEMRmDgXsj7l1hc6ATZG7dcB12rTZrK3Xt0tw9l7tL0gyN1HQwaE1oK4tF0iE+/Dnujvvdw4PG0zUajcbj8WAwoLECAIwxAESHKFGhvyC+8X1/8jSSQgjP8zjjQMDk0SW5/gIFQRDv3O/3HccxDCMuSyclSZIqtc/CEXqVAqbMBsoAMca63e5wOAzD0PM8AGCMdTqdP5gQ4rru9uvtu3fuba2+ab68KGRFccmpv7WMrwwRQrFBBLcYE4ZBOBOnWnXv/b5pmpMJOcV5XMxWtDQuPYKPGXaUsvPJi8PH3xC3gNtgCswsQrnhX/5IK/O3Z27pun49JAWqQ3PxSyN1VlNbmtouy1CU2bFiH0ouyq/38uu9g2jdf+4fvbjaWDhfnt+dtLVN2G21pcqZWmvIjZrc0uTIZ1ghY6NcIpxOsJkYHawEACbGmFAwVyskVW6rWlOp3/BoKxPE80oOcslfO097FGjnu+vUwVILTC0S5VNbuenRphRMJR3kEuG7pSsK9P6D2ScLi5fPqlz68E//P/xwbm55beXnTstJ7lnZ48iX4/43fWb+nDQt+l0AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Colors",
        "title": "Colors",
        "src": "/my-carbon-site/static/5737718955f2cba55b78b5e66b0cc215/3cbba/design-for-ai-art.png",
        "srcSet": ["/my-carbon-site/static/5737718955f2cba55b78b5e66b0cc215/7fc1e/design-for-ai-art.png 288w", "/my-carbon-site/static/5737718955f2cba55b78b5e66b0cc215/a5df1/design-for-ai-art.png 576w", "/my-carbon-site/static/5737718955f2cba55b78b5e66b0cc215/3cbba/design-for-ai-art.png 1152w", "/my-carbon-site/static/5737718955f2cba55b78b5e66b0cc215/0b124/design-for-ai-art.png 1728w", "/my-carbon-site/static/5737718955f2cba55b78b5e66b0cc215/20ee3/design-for-ai-art.png 1896w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`Code`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-mdx",
        "metastring": "path=components/Title/Title.js src=https://github.com/carbon-design-system/gatsby-theme-carbon/tree/main/packages/gatsby-theme-carbon/src/components/Title",
        "path": "components/Title/Title.js",
        "src": "https://github.com/carbon-design-system/gatsby-theme-carbon/tree/main/packages/gatsby-theme-carbon/src/components/Title"
      }}>{`<Title>This is a title</Title>

![Colors](images/design-for-ai-art.png)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      